import { ProgramHeaderItem } from "../types";
import { ProgramType } from "shared/enums/ProgramType";
import TradeProgramStatus from "shared/enums/TradeProgramStatus";
import { ProgramStatusType } from "shared/types/ProgramStatusType";
import BuyersProgramStatus from "shared/enums/BuyersProgramStatus";
import MeetupProgramStatus from "shared/enums/MeetupProgramStatus";
import TabletalkProgramStatus from "shared/enums/TabletalkProgramStatus";
import AssociatedProgramStatus from "shared/enums/AssociateProgramStatus";
import InPersonMeetupProgramStatus from "shared/enums/InPersonMeetupProgramStatus";

export default abstract class BaseEntity {
  getProgramStatusHeaderList(
    programType: ProgramType,
    currentProgramStage: ProgramStatusType,
    programParticipantId?: string
  ): Array<ProgramHeaderItem<ProgramStatusType>> {
    switch (programType) {
      case ProgramType.IN_PERSON_MEETUP_PROGRAM:
        return this.getInPersonMeetupProgramStatusHeaderList();
      case ProgramType.BUYERS_PROGRAM:
        return this.getBuyersProgramStatusHeaderList();
      case ProgramType.MEETUP_PROGRAM:
        return this.getMeetupProgramStatusHeaderList();
      case ProgramType.TRADE_PROGRAM:
        return this.getTradeProgramStatusHeaderList();
      case ProgramType.TABLETALK_PROGRAM:
        return this.getTabletalkProgramStatusHeaderList();
      case ProgramType.ASSOCIATED_PROGRAM:
        return this.getAssociatedProgramStatusHeaderList(
          currentProgramStage as AssociatedProgramStatus,
          programParticipantId
        );

      default:
        return [];
    }
  }

  abstract getInPersonMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<InPersonMeetupProgramStatus>>;
  abstract getBuyersProgramStatusHeaderList(): Array<ProgramHeaderItem<BuyersProgramStatus>>;
  abstract getMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<MeetupProgramStatus>>;
  abstract getTradeProgramStatusHeaderList(): Array<ProgramHeaderItem<TradeProgramStatus>>;
  abstract getTabletalkProgramStatusHeaderList(): Array<ProgramHeaderItem<TabletalkProgramStatus>>;
  abstract getAssociatedProgramStatusHeaderList(
    _: AssociatedProgramStatus,
    _1?: string
  ): Array<ProgramHeaderItem<AssociatedProgramStatus>>;
}
